class EmailTokenPlaceholders {
  public getSenderNamePlaceholder() {
    return 'Jane Bloggs';
  }

  public getContentPlaceholder() {
    let messages = '';
    messages += this.contentPlaceholderMessage('Your appointment is next Friday');
    messages += this.contentPlaceholderMessage('Is that going to be okay?');
    return this.contentPlaceholderContainer(messages);
  }

  private contentPlaceholderContainer(messagesHtml: string) {
    return `<div style="line-height: 18px; font-family: Arial, sans-serif; font-size: 12px; color: #212121">${messagesHtml}</div>`;
  }

  private contentPlaceholderMessage(messageText: string) {
    return `<div style="padding-top: 8px; font-size: 14px; line-height: 36px;"><div style="background-color: #f5f5f5; border-radius: 4px; padding: 12px; line-height: 16px; display: inline-block;">${messageText}</div></div>`;
  }
}

export const emailTokenPlaceholders = new EmailTokenPlaceholders();
